<script lang="ts">
  import { logger } from "$lib/utils/logger";
  import { applyTheme } from "./layoutHelpers";

  /*TODO: future possible uses
    - set flags for things like date/time format
    - shadows
    - border radius
    - dark mode (Set dark mode at night??? Easy on the eyes. "If it was me, at night, I don't want to get blasted by a white screen" - Han)
    - high contrast mode?? (For accessibility)
    - font sizes
    - animations
    - "Consider using CSS utility classes for common font-weight combinations in your component library"
  */

  import { getConfigurationContext } from "$lib/elev8Api/configurationContext.svelte";
  import type { LayoutTheme } from "./layoutTypes";
  import type { Snippet } from "svelte";

  interface Props {
    children?: Snippet;
  }
  const { children }: Props = $props();
  const config = getConfigurationContext();
  const theme = $derived(config.screen?.theme ?? "default");

  const defaultTheme: LayoutTheme = {
    white: "#FAF9F6",
    black: "#28282B",
    primary: "#133256",
    secondary: "#97c7e2",
    accent: "#f04d28",
    neutral: "#ACAEB1",
    neutralDark: "#231f20",
    neutralLight: "#c7c8ca",
    fontH1: "Gilroy",
    fontH2: "Gilroy",
    fontBody: "Fira Sans",
    fontButton: "Gilroy",
    fontWeightH1: "800",
    fontWeightH2: "700",
    fontWeightBody: "400",
    fontWeightButton: "700",
    fontStyleH1: "normal",
    fontStyleH2: "normal",
    fontStyleBody: "normal",
    fontStyleButton: "normal",
    fontSizeBase: "1.0vw", // default is 16px, vw for responsiveness. All other font sizes shall be rem
  };

  const verticalcityTheme: LayoutTheme = {
    ...defaultTheme,
    primary: "#133256",
    accent: "#0ECCC2",
  };

  const verticalImpressionTheme: LayoutTheme = {
    ...defaultTheme,
    accent: "#0ECCC2",
    neutralLight: "#e2f9f7",
    secondary: "#6E4FC6",
  };

  const koneTheme: LayoutTheme = {
    ...defaultTheme,
    white: "#FFFFFF",
    black: "#141414",
    // primary: "#141414",
    primary: "#1450f5",
    accent: "#1450f5", // or #133256; 0066B3
    secondary: "#ffe141",
    neutral: "#3d3f40",
    neutralLight: "#f3eee6",
    // neutralLight: "#F2F3F5",
    // neutralDark: "#1F2328",
    fontH1: "Inter",
    fontH2: "Inter",
    fontBody: "Inter",
    fontButton: "Inter",
    fontWeightH1: "400",
    fontWeightH2: "600",
    fontWeightButton: "600",
  };
  /**
   *    --vc-primary-blue: #133256;
        --vc-primary-grey: #acaeb1;
        --vc-primary-grey-light: #eaebeb;
        --vc-primary-grey-lighter: #f7f7f7;
        --vc-secondary-orange: #f04d28;
        --vc-secondary-blue: #97c7e2;
        --kone-black: #141414;
        --kone-blue: #1450f5;
        --kone-white: #ffffff;
        --kone-sand: #f3eee6;
        --kone-yellow: #ffe141;
        --kone-light-blue: #d2f5ff;
        --kone-pink: #ffcdd7;
        --kone-green: #aae1c8;
   */

  const themeMap: Record<string, LayoutTheme> = {
    verticalcity: verticalcityTheme,
    verticalimpression: verticalImpressionTheme,
    kone: koneTheme,
    default: defaultTheme,
  };

  let resolvedTheme = $derived.by(() => {
    const t = themeMap[theme] ?? defaultTheme;
    logger.debug(`[LayoutTheme] Applying theme: ${theme}`);
    return t;
  });

  $effect(() => {
    applyTheme(resolvedTheme);
  });
</script>

{@render children?.()}
